import { React, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import {
  Accordion,
  AccordionSummary,
  Paper,
  FormControlLabel,
  Tooltip,
  TextField,
  Grid,
  IconButton,
  AccordionDetails,
  Button,
  Box,
  Autocomplete
} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import {
  Search,
  TuneTwoTone
} from '@mui/icons-material';
import { format } from 'date-fns';
import { useForm } from 'react-hook-form';
import genService from 'src/services/generalServices';
import ordenService from 'src/services/ordenService';
import { es as esLocale } from 'date-fns/locale/es';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

const useStyles = makeStyles((theme) => ({
  paperRoot: {
    padding: '2px 6px',
    display: 'contents'
  },
  accordionSumm: {
    padding: 0,
    display: 'flex',
    '&.MuiAccordionSummary-root': {
      background: 'transparent'
    },
    '& .MuiIconButton-edgeEnd': {
      marginRight: 5
    }
  },
  bottomSpace: {
    marginBottom: theme.spacing(3),
  },
  input: {
    marginLeft: theme.spacing(1),
    display: 'flex'
  },
  combo: {
    marginLeft: theme.spacing(1),
    display: 'flex',
    width: '100%'
  },
  iconButton: {
    alignItems: 'center'
  },
}));

const BusquedaEvaluaciones = ({
  comboEscuelas,
  mostrarBusqueda,
  setMostrarBusqueda,
  comboOrdenEstatus,
  setRowsOrdenes,
  setLoading,
  setServerError,
  setOpenSnackError,
}) => {
  const {
    handleSubmit,
    register,
    formState: { errors }
  } = useForm();
  const paperRef = useRef();
  const classes = useStyles();
  const [valueCombo, setValueCombo] = useState([]);
  const [valueComboEstatus, setValueComboEstatus] = useState([]);
  const [openFechaDesde, setOpenFechaDesde] = useState(false);
  const [fechaDesde, setFechaDesde] = useState(null);
  const [openFechaHasta, setOpenFechaHasta] = useState(false);
  const [fechaHasta, setFechaHasta] = useState(null);

  const onSubmit = (formulario) => {
    if (valueCombo !== null && valueCombo !== undefined) {
      formulario.idCliente = valueCombo.value;
    }
    if (!mostrarBusqueda) {
      if (fechaDesde !== null && fechaDesde !== '') {
        formulario.desde = format(fechaDesde, 'yyyy-MM-dd');
      }
      if (fechaHasta !== null && fechaHasta !== '') {
        formulario.hasta = format(fechaHasta, 'yyyy-MM-dd');
      }
      if (valueComboEstatus !== null && valueComboEstatus !== undefined) {
        formulario.idOrdenEstatus = valueComboEstatus.value;
      }
    }
    const asyncCall = async (datos) => {
      setLoading(true);
      await ordenService.searchOrdenes(datos, true).then((resp) => {
        setRowsOrdenes(resp.data);
      }).catch((error) => {
        setRowsOrdenes([]);
        if (error.response) {
          setServerError(error.response.data.message);
        } else {
          setServerError(`${error.message}: No fue posible conectar con el servidor`);
        }
        setOpenSnackError(true);
        setLoading(false);
      });
      setLoading(false);
    };
    asyncCall(formulario);
    console.log('Formulario busqueda de ordenes:', formulario);
    console.log(comboEscuelas);
  };

  return (
    <Paper
      ref={paperRef}
      component="form"
      className={classes.paperRoot}
      onSubmit={handleSubmit(onSubmit)}
    >
      <Accordion>
        <AccordionSummary
          expandIcon={(
            <Tooltip title="Búsqueda Avanzada">
              <TuneTwoTone />
            </Tooltip>
          )}
          onClick={() => setMostrarBusqueda(!mostrarBusqueda)}
          className={classes.accordionSumm}
        >
          <Grid
            container
            spacing={3}
            sx={{
              justifyContent: 'center',
              width: '100%'
            }}
          >
            <Grid
              size={{
                xs: 12,
                md: 8,
                lg: 8
              }}
            >
              <FormControlLabel
                onClick={(event) => event.stopPropagation()}
                onFocus={(event) => event.stopPropagation()}
                className={classes.combo}
                control={(
                  <Autocomplete
                    id="combo-box-escuelas"
                    options={comboEscuelas}
                    getOptionLabel={(option) => (option.label ? option.label : '')}
                    value={valueCombo}
                    fullWidth
                    className={classes.combo}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Seleccione un Cliente"
                        variant="outlined"
                        size="small"
                        error={!!errors.regEscuelas}
                        helperText={errors.regEscuelas?.message}
                        onInput={genService.toUpperCase}
                        {...register('regEscuelas')}
                      />
                    )}
                    onChange={(event, newValue) => {
                      console.log(newValue);
                      setValueCombo(newValue);
                    }}
                  />
                )}
              />
            </Grid>
            <Grid
              size={{
                sm: mostrarBusqueda ? 8 : 11,
                xs: mostrarBusqueda ? 8 : 11,
                md: 3
              }}
            >
              <FormControlLabel
                onClick={(event) => event.stopPropagation()}
                onFocus={(event) => event.stopPropagation()}
                className={classes.input}
                control={(
                  <TextField
                    fullWidth
                    className={classes.input}
                    label="Folio"
                    size="small"
                    {...register('folio')}
                    onInput={genService.toUpperCase}
                    variant="outlined"
                  />
                )}
              />
            </Grid>
            <Grid
              align="right"
              style={{ visibility: mostrarBusqueda ? 'visible' : 'hidden' }}
              size={{
                xs: 1,
                md: 1,
                sm: 1,
                lg: 1
              }}
            >
              <FormControlLabel
                onClick={(event) => event.stopPropagation()}
                onFocus={(event) => event.stopPropagation()}
                className={classes.input}
                control={(
                  <IconButton
                    className={classes.iconButton}
                    aria-label="search"
                    type="submit"
                    size="large"
                  >
                    <Search />
                  </IconButton>
                )}
              />
            </Grid>
          </Grid>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container spacing={3}>
            <Grid
              size={{
                md: 6,
                xs: 12,
                lg: 6
              }}
            >
              <FormControlLabel
                onClick={(event) => event.stopPropagation()}
                onFocus={(event) => event.stopPropagation()}
                className={classes.input}
                control={(
                  <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={esLocale}>
                    <DatePicker
                      open={openFechaDesde}
                      onOpen={() => setOpenFechaDesde(true)}
                      onClose={() => setOpenFechaDesde(false)}
                      onChange={setFechaDesde}
                      format="dd/MM/yyyy"
                      label="Desde"
                      value={fechaDesde}
                      slotProps={{
                        textField: {
                          name: 'desde',
                          margin: 'normal'
                        }
                      }}
                    />
                  </LocalizationProvider>
                )}
              />
            </Grid>
            <Grid
              size={{
                md: 6,
                xs: 12,
                lg: 6
              }}
            >
              <FormControlLabel
                onClick={(event) => event.stopPropagation()}
                onFocus={(event) => event.stopPropagation()}
                className={classes.input}
                control={(
                  <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={esLocale}>
                    <DatePicker
                      open={openFechaHasta}
                      onOpen={() => setOpenFechaHasta(true)}
                      onClose={() => setOpenFechaHasta(false)}
                      onChange={setFechaHasta}
                      format="dd/MM/yyyy"
                      label="Hasta"
                      value={fechaHasta}
                      slotProps={{
                        textField: {
                          name: 'hasta',
                          margin: 'normal',
                          variant: 'outlined'
                        }
                      }}
                    />
                  </LocalizationProvider>
                )}
              />
            </Grid>
            <Grid
              size={{
                md: 6,
                xs: 12
              }}
            >
              <FormControlLabel
                onClick={(event) => event.stopPropagation()}
                onFocus={(event) => event.stopPropagation()}
                className={classes.input}
                control={(
                  <TextField
                    fullWidth
                    label="Alumno"
                    size="small"
                    {...register('investigado')}
                    onInput={genService.toUpperCase}
                    variant="outlined"
                  />
                )}
              />
            </Grid>
            <Grid
              size={{
                md: 6,
                xs: 12,
                sm: 6
              }}
            >
              <FormControlLabel
                onClick={(event) => event.stopPropagation()}
                onFocus={(event) => event.stopPropagation()}
                className={classes.input}
                control={(
                  <Autocomplete
                    id="combo-box-estatus"
                    options={comboOrdenEstatus}
                    getOptionLabel={(option) => (option.label ? option.label : '')}
                    fullWidth
                    value={valueComboEstatus}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Seleccione un Estatus"
                        variant="outlined"
                        size="small"
                        error={!!errors.ordenStatus}
                        helperText={errors.ordenStatus?.message}
                        onInput={genService.toUpperCase}
                        {...register('ordenStatus')}
                      />
                    )}
                    onChange={(event, newValue) => {
                      console.log(newValue);
                      setValueComboEstatus(newValue);
                    }}
                  />
                )}
              />
            </Grid>
            <Grid
              size={{
                xs: 12,
                md: 12
              }}
            >
              <div className={classes.bottomSpace} />
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'center'
                }}
              >
                <Button
                  color="primary"
                  variant="contained"
                  type="submit"
                >
                  Buscar
                </Button>
              </Box>
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>
    </Paper>
  );
};

BusquedaEvaluaciones.propTypes = {
  comboEscuelas: PropTypes.array,
  mostrarBusqueda: PropTypes.bool,
  setMostrarBusqueda: PropTypes.func,
  comboOrdenEstatus: PropTypes.array,
  setRowsOrdenes: PropTypes.func,
  setLoading: PropTypes.func,
  setServerError: PropTypes.func,
  setOpenSnackError: PropTypes.func
};

export default BusquedaEvaluaciones;
